// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__3ZtY-","fillColor":"IconSuccess_fillColor__2T7Cl"};